import * as React from 'react';
import { pathwayStore } from '../../store';
import { useZustand } from 'use-zustand';
import { Config, isCompleted, navigateToURL } from '../../helper';
import { Button, SkipButton } from '../Buttons';
import Footer from '../Footer';
import BrokenStep from './BrokenStep';

export default function PathwayStep({step, index, currentStep}) {
  const {
    config = {},
    optional = false,
    broken = false
  } = step;

  const {
    url = null,
    cta = Config.I18n.Action.Next,
    completedCta = Config.I18n.Action.ReadAgain,
  } = config;

  const {
    updateStep,
    pathwayID,
    completedStepIDs,
    skippedStepIDs,
  } = useZustand(pathwayStore, (state) => ({
    pathwayID: state.pathwayID,
    updateStep: state.updateStep,
    completedStepIDs: state.completedStepIDs,
    skippedStepIDs: state.skippedStepIDs,
  }));

  const completed = isCompleted(step.id, completedStepIDs());
  const skipped = isCompleted(step.id, skippedStepIDs());

  const skipStep = (evt) => {
    evt.preventDefault();
    updateStep(pathwayID, step, Config.Step.Status.skipped);
  }

  const completeStep = (evt) => {
    evt.preventDefault();
    evt.target.disabled = true;
    updateStep(pathwayID, step, Config.Step.Status.completed);
    navigateToURL(url);
  }

  const readAgain = () => {
    navigateToURL(url);
  };

  if (broken) {
    return <BrokenStep/>;
  }

  return (
    <div className='pathway-step__details'>
      <div className='pathway-step__content'>
        <div className='pathway-step__main' dangerouslySetInnerHTML={{__html: step.content}}></div>
      </div>
      <div className='pathway-step__actions'>
        {optional && !skipped && !completed && <SkipButton text={Config.I18n.Action.Skip} completed={completed} clickHandler={skipStep}/>}
        {!completed && <Button text={cta} disabled={completed} clickHandler={completeStep}/>}
        {completed && <Button text={completedCta} clickHandler={readAgain}/>}
      </div>
      <Footer content={step.footer}/>
    </div>
  );
}
